/**
 * Created by vhe on 3/2/2017.
 */
'use strict';
import angular from 'angular';
import ProductCardController from './product-card.controller';
import AlternateProductCardController from './alternate-product-card.controller';
export default angular.module('directives.productCard', [])
    .controller('ProductCardController', ProductCardController)
    .component('productCard', {
    template: require('./product-card.html'),
    bindings: {
        itemCode: '<',
        config: '<',
        isauth: '<',
        userData: '<'
    },
    controller: ProductCardController
})
    .component('alternateProductCard', {
    template: require('./alternate-product-card.html'),
    bindings: {
        itemCode: '<',
        config: '<',
        isauth: '<',
        userData: '<'
    },
    controller: AlternateProductCardController
})
    .component('productQuantityFrom', {
    template: require('./product-quantity-from.html'),
    bindings: {
        itemCode: '<',
        config: '<',
        currentItem: '<',
        showCartText: '<',
        disableCart: '&',
        getDisableCartPopupMessage: '&'
    },
    controller: ProductCardController,
    controllerAs: 'pQty'
})
    .name;
//# sourceMappingURL=index.js.map